import moment from "moment";
import { Modal } from "antd";
import styles from "./savedtemplate.module.scss";
import React, { useEffect, useState } from "react";
import { URButton } from "../../../../shared/widgets/button";
import { toastInformation } from "../../../../base/callService/common";
import { storeMeetingPage, storeTemplate, storeTemplateList, storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import { deleteMeetingTemplate, getTemplateList } from "../../../../base/meetingService/apiService";
import { useSelector } from "react-redux";
import  URmeetGridSkeleton  from "../../../../shared/skeletonLoading/meetingGridSkeleton";
import URmeetListSkeleton from '../../../../shared/skeletonLoading/meetingListSkeleton'
import { URInput } from "../../../../shared/widgets/input";
type savedTemplateState = {
  templates: Array<any>;
  currentMode: string;
  isdeletePopup: boolean;
  templateId: string;
  offset: number;
  limit: number;
  isTitle: number;
  isDate: number;
  sortType: string;
}

export default function SavedTemplateViewList() {
  let { meetingReducer }: any = useSelector((state: any) => state);
  let {templateList,getTemplateListInput,storeTemplateListSortValue,templateListLoader } = meetingReducer;
  const [getData, setData] = useState<savedTemplateState>({
    templates: [], currentMode: 'grid', isdeletePopup: false,
    templateId: '', offset: 0, limit: 20, sortType: 'date',
    isTitle:1, isDate:1
  });

  const deletePopup = (templateId: string) => {
    setData({ ...getData, isdeletePopup: true,templateId:templateId});
  };

  /*const popupConfirm = (status: string) => {
    console.log("popupConfirm calling");

    // let seletedTemplate: any = document.getElementById(getData.templateId);
    // if (seletedTemplate) {
    //   seletedTemplate.parentNode.removeChild(seletedTemplate);
    // }

    if (status === 'delete') {
      new MeetingService().deleteTemplate(getData.templateId).then((response: any) => {
        if (response.statusCode === 200) {
          let seletedTemplate: any = document.getElementById(getData.templateId);
          if (seletedTemplate) {
            // seletedTemplate.parentNode.removeChild(seletedTemplate);
          }
        setData({ ...getData, isdeletePopup: false });
        // let index = _.findIndex(getData.templates, { template_id: getData.templateId });
        // if (index !== -1) {
          // getData.templates.splice(index, 1);
          // if (getData.templates.length < getData.limit) {
           let input:any= {};
        input.isDate = storeTemplateListSortValue.isDate;
        input.isTitle = storeTemplateListSortValue.isTitle;
            let data: any = {};
            data.offset = 0;
            data.limit = getTemplateListInput.limit;
            data.sort = (getTemplateListInput.sortType === 'date') ? storeTemplateListSortValue.isDate : storeTemplateListSortValue.isTitle;
            data.sortType =  getTemplateListInput.sortType;
            getTemplateList(data,input);
          // }
        // }
        //else { setData({ ...getData, isdeletePopup: false, templateId: '' }); }
        toastInformation('template deleted Successfully', 'success');
        }
      })
        .catch((err: any) => {
          console.log("error is", err);
          toastInformation(err, 'failure');
          setData({ ...getData, isdeletePopup: false, templateId: '' });
        });
    }
    else { setData({ ...getData, isdeletePopup: false, templateId: '' }); }
    //setData({ ...getData, isdeletePopup: false, templateId: '' });
  };*/

  const changeView = (mode:string) => {
     storeTemplateList([]);
    let input:any= {};
    input.isDate = -1;
    input.isTitle = -1;
    let { limit } = getData;
    let data: any = {};
    data.offset =getTemplateListInput.offset ;
    data.limit = limit;
    data.sort = getTemplateListInput.sort;
    data.sortType =getTemplateListInput.sortType;
    getTemplateList(data,input);
    setData({...getData, currentMode:mode});
  };

  const popupConfirm = (status: any) => {
    if (status === 'delete') {
      deleteMeetingTemplate(getData.templateId).then((res: any) => {
       if(res.statusCode===200)
        {
        setData({ ...getData, isdeletePopup: false,templateId: ''});
        toastInformation(res.message,"success");}
      });
    }
    else {
      setData({ ...getData, isdeletePopup: false, templateId: '' });
    }
  }

  // const getTemplateList = (data: any) => {
  //   console.log("data is", data);
  //   new MeetingService().getTemplatesList(data).then((res: any) => {
  //     if (res.statusCode === 200) {
  //       if (data.offset !== 0) {
  //       res.result = getData.templates.concat(res.result);
  //     }
  //     setData({
  //       ...getData, templates: res.result, offset: data.offset, sortType: data.sortType,
  //       isDate: (data.sortType === 'date') ? data.sort : getData.isDate,
  //       isTitle: (data.sortType === 'title') ? data.sort : getData.isTitle,
  //       isdeletePopup: false, templateId: ''
  //     });}
      
  //   })
  //     .catch((err: any) => {
  //       setData({ ...getData, isdeletePopup: false, templateId: '' });
  //     });
  // };


  const previewTemplate = (value:any) => {
    storeMeetingPage(value.template);
    storeWindowState("templateDetails");
    storeTemplate(value);
  };

  const scrollEvent = (e: any) => {
    let {limit} = getData;
    const bottom = e.target.scrollHeight - Math.abs(e.target.scrollTop) === e.target.clientHeight;
    if (bottom) {
      if (getData.currentMode === 'list') {
         let input:any= {};
        input.isDate = storeTemplateListSortValue.isDate;
        input.isTitle = storeTemplateListSortValue.isTitle;
        let data: any = {};
        data.offset = getTemplateListInput.offset+getTemplateListInput.limit;
        data.limit = limit;
        data.sort = (getTemplateListInput.sortType === 'date') ? storeTemplateListSortValue.isDate : storeTemplateListSortValue.isTitle;
        data.sortType = getTemplateListInput.sortType;
        getTemplateList(data,input);
      }
      else {
        let input:any= {};
        input.isDate = storeTemplateListSortValue.isDate;
        input.isTitle = storeTemplateListSortValue.isTitle;
        let data: any = {};
        data.offset = getTemplateListInput.offset+getTemplateListInput.limit;
        data.limit = limit;
        data.sort = -1;
        data.sortType = "date";
        getTemplateList(data,input);
      }
    }
  };

  const templateFilter = (status:string) => {
    storeTemplateList([]);
    let {limit} = getData;
     let input:any= {};
        input.isDate = storeTemplateListSortValue.isDate;
        input.isTitle = storeTemplateListSortValue.isTitle;
    let data: any = {};
    data.offset = 0;
    data.limit = limit;
    data.sort = (status === 'date' ? ((storeTemplateListSortValue.isDate === 1) ? -1 : 1) : (storeTemplateListSortValue.isTitle === 1) ? -1 : 1);
    data.sortType = status;
    getTemplateList(data,input);
  };
 
  useEffect(() => {
    storeTemplateList([]);
    let input:any= {};
    input.isDate = -1;
    input.isTitle = -1;
    let { limit } = getData;
    let data: any = {};
    data.offset =getTemplateListInput.offset ;
    data.limit = limit;
    data.sort = getTemplateListInput.sort;
    data.sortType =getTemplateListInput.sortType;
    getTemplateList(data,input);
    // return () => {
    //   console.log("save template unmount");
    // };
  }, []);

  const templateUse = (value: any) => {
    storeMeetingPage(value.template);
    storeWindowState("useTemplate");
  };
  
  return (
    <>

      <div className={styles.savedtemplateview}>
        <div className={styles.rightbartop}>
          <div className={styles.lefts}>
            <ul>
              <li className={ `${getData.currentMode === 'grid' && styles.active}` }>
                <span className="icon_Keypadfill" onClick={() => changeView('grid')}></span></li>
              <li className={`${getData.currentMode === 'list' && styles.active}`}>
                <span className="icon_listview" onClick={() => changeView('list')}></span></li>
            </ul>
          </div>
          <div className={styles.rights}>	
            <URInput placeHolder="Search" className="leftbarsearch"></URInput>	
          </div>
        </div>
        <div className={`${'scroller'} ${styles.rightbarbottom} ${styles.gridviewevent}`}
          onScroll={(e:any)=>scrollEvent(e)}>
          {getData.currentMode === 'grid' &&  <div className={styles.savedgridlist}>
            {/* <div className={`${styles.listsection} ${styles.active}`}>
              <h3>Slate & Crystal Events</h3>
              <h6>Last Modified Time</h6>
              <p>Aug 12, 2021 <span className={styles.dotstag}>&bull;</span> 12:00 PM</p>
              <div className="gridbtns">
                <URButton className="usetemplatebtn" name="Use this Template" />
                <URButton className="deletebtn" name="Delete" onClick={showModal4} />
              </div>
            </div> */}
            {templateList && templateList.map((value: any, index:number) => {
              return (
                  <div className={styles.listsection} id={value.template_id} key={index}>
                    <div className={styles.templateclickarea} onClick={() => previewTemplate(value)}>
                    <h3>{ value.template.title }</h3>
                    <h6>Last Modified Time</h6>
                    <p>{moment(value.template.start_timestamp).format("MMM DD YYYY")}
                      <span className={styles.dotstag}>&bull;</span>
                      {moment(value.template.start_timestamp).format("LT")}</p>
                    </div>
                    <div className={`gridbtns ${styles.gridbtnsone}`}>
                      <URButton className="deletebtn" name="Delete" onClick={()=>deletePopup(value.template_id)} />
                      <URButton className="usetemplatebtn" name="Use this Template" onClick={()=>templateUse(value)}/>
                    </div>
                  </div>
              );
            })
            }
            {templateList?.length === 0 && templateListLoader && getData.currentMode === 'grid' && 
              [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12,13,14,15,16,17,18,19,20]?.map((index: any) => (
              <div className={styles.listsection} key={index}><URmeetGridSkeleton /></div>
            ))
            }{templateList?.length === 0 && !templateListLoader &&
              <p>No Data</p>
            }
          </div>}

          {getData.currentMode === 'list' && <div className={styles.savelistview}>
            <div className={styles.tabletopsection}>
              <div className={styles.temptitle}>
                <p onClick={()=>templateFilter('title')}>Template Title<span className={(storeTemplateListSortValue.isTitle === -1 && getTemplateListInput.sortType==="title") ? "icon_uparrow" : "icon_down-arrow"}></span></p>
                {/* <p>Template Title <span className="icon_uparrow"></span></p> */}
              </div>
              <div className={styles.modifydate}>
                <p onClick={()=>templateFilter('date')}>Last Modified Date <span className={(storeTemplateListSortValue.isDate === -1 && getTemplateListInput.sortType==="date") ? "icon_uparrow" : "icon_down-arrow"}></span></p>
              </div>
              <div className={styles.actions}>
                <p>Action Items</p>
              </div>
            </div>
            {templateList && templateList.map((value: any,index:number) => {
              return (
                  <div className={styles.viewlistsection} id={value.template_id} key={index}>
                    <div className={styles.title} onClick={() => previewTemplate(value)}>
                      <h3>{value.template.title}</h3>
                    </div>
                    <div className={styles.datetime}>
                      <p>{moment(value.template.start_timestamp).format("MMM DD YYYY")}
                        <span className={styles.dotstag}>&bull;</span>
                        {moment(value.template.start_timestamp).format("LT")}
                      </p>
                    </div>
                    <div className={`gridbtns ${styles.listbuttons}`}>
                      <URButton className="usetemplatebtn" name="Use this Template" onClick={()=>templateUse(value)}/>
                      <URButton className="deletebtn" name="Delete" onClick={()=>deletePopup(value.template_id)} />
                    </div>
                  </div>
              );
            })
            }
          </div>}
          {templateList?.length === 0 && templateListLoader && 
              [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12,13,14,15,16,17,18,19,20]?.map((index: any) => (
              <div className={styles.listsection} key={index}><URmeetListSkeleton /></div>
            ))
            }
            {templateList?.length === 0 && !templateListLoader &&  getData.currentMode === 'list' && 
              <p>No Data</p>
            }
        </div>
      </div>

      <Modal visible={getData.isdeletePopup} title="Delete this Saved Template?"
        centered
        onOk={()=>popupConfirm('delete')}
        onCancel={()=>popupConfirm('cancel')}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
         This template will be permanently deleted from the list.
      </Modal>
    </>
  );
};

